/**
 * Class responsible for adding/removing CSS styles for applying the active font and font previews
 */
export default class StyleManager {
  constructor ( pickerName, activeFont, variants ) {
    if ( pickerName !== '' ) {
      this.pickerSuffix = `-${pickerName}`
    } else {
      this.pickerSuffix = ''
    }
    this.stylesheetId = `font-selectors${this.pickerSuffix}`
    this.previews = []
    this.determineFontVariants( variants )
  }

  /**
	 * Determine the specified font variants (style and weight) and save them in the corresponding
	 * object variables
	 */
  determineFontVariants ( variants ) {
    // Font weight/style for previews: split number and text in font variant parameter
    const defaultVariant = variants[0].split( /(\d+)/ ).filter( Boolean )

    // Determine font variants which will be applied to the fonts in the font picker and to elements
    // of the .apply-font class
    if ( defaultVariant.length === 1 ) {
      // Either font weight or style is specified (e.g. 'regular, '300', 'italic')
      if ( defaultVariant[0] === 'regular' || defaultVariant[0] === 'italic' ) {
        // Font style is specified
        [ this.fontStyle ] = defaultVariant
        this.fontWeight = '400'
      }	else {
        // Font weight is specified
        this.fontStyle = 'regular';
        [ this.fontWeight ] = defaultVariant
      }
    }	else if ( defaultVariant.length === 2 ) {
      // Both font weight and style are specified
      [ this.fontWeight, this.fontStyle ] = defaultVariant
    }
  }

  /**
	 * Generate the selector for the default font, set up the font picker's stylesheet and add it to
	 * the document head
	 */
  initStylesheet ( activeFont ) {
    this.stylesheet =  {
      fontFamily: activeFont.family,
      fontStyle: this.fontStyle,
      fontWeight: this.fontWeight
    }
  }

  /**
	 * Add CSS selector for applying a preview font
	 */
  applyPreviewStyle ( font ) {
    const fontId = font.family.replace( /\s+/g, '-' ).toLowerCase()
    const style = {
      id: fontId,
      fontFamily: font.family,
      fontStyle: this.fontStyle,
      fontWeight: this.fontWeight
    }
    this.previews.push( style )
  }

  /**
	 * Update the CSS selector for applying the active font to the .apply-font class
	 */
  changeActiveStyle ( activeFont, previousFont ) {
    const fallbackFont = activeFont.category === 'handwriting' ? 'cursive' : activeFont.category
    this.stylesheet = {
      fontFamily: `"${activeFont.name ? activeFont.name : activeFont.family}", "${previousFont}", ${fallbackFont}`,
      fontStyle: this.fontStyle,
      fontWeight: this.fontWeight,
      fontPath: activeFont.path ? activeFont.path : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/commons/FontManager/StyleManager.js